<template>
	<v-select
		v-bind="$attrs"
		:class="{ 'app-select-border-total' : borderTotal, 'app-select': !borderTotal, 'app-form-component': !isQinti && !isLucky, 'app-form-component-quinti': isQinti || isLucky}"
		hide-details
		@input="onInput"
	></v-select>
</template>

<script>
	function onInput(value) {
		this.$emit('input', { model: this.model, value });
	}

	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	export default {
		name: 'app-select',
		inheritAttrs: false,
		methods: {
			onInput,
		},
		computed: {
			isQinti,
			isLucky,
		},
		props: {
			model: String,
			borderTotal: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>

<style lang="scss">
	.app-select {
		border-bottom: 2px solid color(info);

		&-border-total {
			.input-group__input {
				border: 2px solid color(primary);
				border-radius: 4px;
				padding: 0 0 0 8px;
			}
		}
	}

	.app-form-component-quinti {
		&.app-select-border-total {
			.input-group__input {
				border: 2px solid #bcbcbc !important;
			}
		}
	}

	.app-form-component-quinti {
		&.app-select {
			border-bottom: 2px solid #bcbcbc !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/form/app-select.vue